/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import {
  getBrand,
  getIconPath,
  getLocator,
  routeToStoreDetails,
  updateStoreDataLocalStorage,
} from '@tcp/core/src/utils';
import { getStoreHours } from '@tcp/core/src/utils/utils.extension';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import {
  STORE_LANDING_LABELS,
  STORE_LIST_LABELS,
  StoreLocatorLabels,
  STORE_DETAILS_LABELS,
} from '@tcp/core/src/components/features/storeLocator/Labels/StoreLocator.labels';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import HeaderLabels, {
  BROWSE_LABELS,
  STORE_LOCATOR_LABELS,
} from '../../../labels/HeaderNew.labels';
import style, { StoreLocatorDetails } from '../styles/StoreLocatorLink.style';
import ClickTracker from '../../../../../../common/atoms/ClickTracker';
import { StoreIcon, StorePin, StorePinNew, CloseIcon } from '../../HeaderIcons/HeaderSvgIcons';

const timeStampCheck = (currentStore, storeToBeWrittenToLocalStorage) => {
  // Making sure store getting written to local storage has a newer timestamp and is a newer version.
  const currentStoreTimeStamp =
    currentStore?.favStoreTimeStamp || currentStore?.akamaiStoreTimeStamp;
  const storeToBeWrittenToLocalStorageTimeStamp =
    storeToBeWrittenToLocalStorage?.favStoreTimeStamp ||
    storeToBeWrittenToLocalStorage?.akamaiStoreTimeStamp;
  if (currentStoreTimeStamp && storeToBeWrittenToLocalStorageTimeStamp) {
    return new Date(currentStoreTimeStamp) < new Date(storeToBeWrittenToLocalStorageTimeStamp);
  }
  return false;
};

const getDefaultStore = () => {
  return JSON.parse(getLocalStorage('defaultStore')) || '';
};

const timeStampExistingCheck = (store) => {
  return !store?.favStoreTimeStamp && !store?.akamaiStoreTimeStamp;
};

const openStoreDetails = (event, store, resetCurrentStoreInfo, onLinkClick, basicInfo) => {
  event.preventDefault();
  setTimeout(() => {
    onLinkClick();
    if (basicInfo?.storeName) {
      const { routerHandler } = routeToStoreDetails(store);
      resetCurrentStoreInfo();
      routerHandler();
    }
  }, 0);
};

const renderStoreDetailDropDown = ({
  basicInfo,
  storeTime,
  onLinkClick,
  onStorePinClicked,
  showStoreDetails,
  handleChangeStoreClick,
  handleShopThisStoreClick,
  headerMiddleNavHeight,
  fromCondensedHeader,
  isShopThisStoreEnabled,
  storeData,
  resetCurrentStoreInfo,
}) => {
  const browseLabels = getLabelFromCopyOrFromTranslation(BROWSE_LABELS, HeaderLabels);
  const storeLocatorLabels = getLabelFromCopyOrFromTranslation(STORE_LOCATOR_LABELS, HeaderLabels);

  const selectDifferentStore = renderLabel(
    storeLocatorLabels?.StoreDetail?.lbl_storedetails_selectDifferentStore,
    'lbl_storedetails_selectDifferentStore'
  );

  const selectStoreBtn = renderLabel(
    storeLocatorLabels?.StoreLanding?.lbl_storedetail_selectstore_btn,
    'lbl_storedetail_selectstore_btn'
  );

  const pickupSelectedStore = renderLabel(
    browseLabels?.ProductPickup?.lbl_Product_pickup_SELECTED_STORE,
    'lbl_Product_pickup_SELECTED_STORE'
  );
  const urlData = basicInfo?.storeName ? routeToStoreDetails(storeData)?.url : '/store-locator';
  return (
    <Suspense>
      <Modal
        isOpen={showStoreDetails}
        overlayClassName="TCPModal__Overlay"
        onRequestClose={onStorePinClicked}
        noPadding
        id="modalWrapper"
        widthConfig={{ small: '100%' }}
        className="TCPModal__Content Modal_Heading_Overlay modal-store-details"
        heading="Store Details Modal"
        fixedWidth
        stickyHeader
        headingAlign="center"
        horizontalBar={false}
        innerContentClassName="modal-inner-content-wrapper"
        inheritedStyles={StoreLocatorDetails}
        showHeading
        title="Welcome,Guest"
        headerMiddleNavHeight={headerMiddleNavHeight}
        fromCondensedHeader={fromCondensedHeader}
      >
        <div className={`selected-store-wraper ${basicInfo?.storeName ? '' : 'no-store'}`}>
          <ClickTracker
            clickData={{
              customEvents: ['event80'],
              eVar65: 'storelocator',
            }}
          >
            <Anchor
              dataLocator={getLocator('store_drawerlink')}
              fontSizeVariation="small"
              anchorVariation="primary"
              to={`${urlData}`}
              onClick={(event) =>
                openStoreDetails(event, storeData, resetCurrentStoreInfo, onLinkClick, basicInfo)
              }
              className={`store-locator-link store-locator-link-${getBrand()}`}
            >
              {basicInfo?.storeName && (
                <BodyCopy
                  component="div"
                  data-locator={getLocator('store_selected_storelabel')}
                  fontFamily="secondary"
                  fontSize="fs13"
                  className="selected-store-lbl"
                >
                  {pickupSelectedStore}
                </BodyCopy>
              )}

              <div className="content">
                <div className="storelocatorlink__img">
                  <Image
                    src={getIconPath('marker-icon')}
                    alt="Store Locator"
                    className="storelocator--image"
                    data-locator={getLocator('store_markericon')}
                  />
                </div>
                {basicInfo?.storeName ? (
                  <div className="storelocatorlink__detail">
                    <BodyCopy
                      component="div"
                      data-locator={getLocator('store_namelabel')}
                      fontFamily="secondary"
                      fontSize="fs13"
                      className="storelocatorlink__detail__storename"
                    >
                      {basicInfo?.storeName}
                    </BodyCopy>
                    <BodyCopy
                      component="div"
                      data-locator={getLocator('store_storetime')}
                      fontFamily="secondary"
                      fontSize="fs10"
                      className="storelocatorlink__detail__storetime"
                    >
                      {storeTime}
                    </BodyCopy>
                  </div>
                ) : (
                  <BodyCopy
                    component="div"
                    data-locator={getLocator('store_selected_storelabel')}
                    fontFamily="secondary"
                    fontSize="fs13"
                    className="select-store-lbl"
                  >
                    {renderLabel(
                      storeLocatorLabels?.StoreLanding?.lbl_storelanding_findStoreHeading,
                      'lbl_storelanding_findStoreHeading'
                    ).toUpperCase()}
                  </BodyCopy>
                )}
              </div>
            </Anchor>
          </ClickTracker>
        </div>

        <div className="change-store-wrapper">
          {/* DO NOT REMOVE::: shop-this-store is  intensionally make Hidden  as the feature is not ready, can be used in future  */}
          {isShopThisStoreEnabled && basicInfo && (
            <span>
              <StoreIcon className="store-locator-svg" />
              <BodyCopy
                component="span"
                onClick={() => handleShopThisStoreClick(basicInfo)}
                data-locator={getLocator('store_shopthis_storelabel')}
                fontFamily="secondary"
                fontSize="fs13"
                className="shop-this-store"
              >
                {renderLabel(
                  storeLocatorLabels?.StoreDetail?.lbl_storedetails_shopThisStore,
                  'lbl_storedetails_shopThisStore'
                )}
              </BodyCopy>
            </span>
          )}
          <BodyCopy
            component="span"
            onClick={() => handleChangeStoreClick(basicInfo?.storeName)}
            data-locator={getLocator('store_selectdifferent_storelabel')}
            fontFamily="secondary"
            fontSize="fs12"
            className="select-different-store"
          >
            {basicInfo?.storeName ? selectDifferentStore : selectStoreBtn}
          </BodyCopy>
        </div>
      </Modal>
    </Suspense>
  );
};

const renderIcon = (brandId, isNewMiddleNavSection) => {
  return isNewMiddleNavSection ? <StorePinNew brand={brandId} /> : <StorePin brand={brandId} />;
};

const StoreLocatorLink = (props) => {
  const {
    className,
    store,
    onLinkClick,
    brandId,
    onStorePinClicked,
    showStoreDetails,
    handleChangeStoreClick,
    handleShopThisStoreClick,
    headerMiddleNavHeight,
    fromCondensedHeader,
    isShopThisStoreEnabled,
    isNewMiddleNavSection,
    resetCurrentStoreInfo,
  } = props;
  const storeLabels = {
    ...getLabelFromCopyOrFromTranslation(STORE_DETAILS_LABELS, StoreLocatorLabels),
    ...getLabelFromCopyOrFromTranslation(STORE_LANDING_LABELS, StoreLocatorLabels),
    ...getLabelFromCopyOrFromTranslation(STORE_LIST_LABELS, StoreLocatorLabels),
  };
  let storeToBeWrittenToLocalStorage = store;
  if (store) {
    const currentDate = new Date();
    if (timeStampExistingCheck(store)) {
      storeToBeWrittenToLocalStorage.favStoreTimeStamp = currentDate;
    }
    const currentStore = getDefaultStore();
    if (
      store?.basicInfo?.storeName !== '' &&
      (timeStampCheck(currentStore, storeToBeWrittenToLocalStorage) ||
        !currentStore ||
        currentStore === '')
    ) {
      updateStoreDataLocalStorage(storeToBeWrittenToLocalStorage); // set only if current timestamp is older
    }
  } else {
    storeToBeWrittenToLocalStorage = getDefaultStore();
  }
  const basicInfo =
    (storeToBeWrittenToLocalStorage && storeToBeWrittenToLocalStorage?.basicInfo) ||
    store?.basicInfo;
  const currentDate = new Date();
  const hours = storeToBeWrittenToLocalStorage && storeToBeWrittenToLocalStorage.hours;
  const storeTime = hours && getStoreHours(hours, storeLabels, currentDate);
  const storeData = storeToBeWrittenToLocalStorage || store || {};
  return (
    <React.Fragment>
      <BodyCopy
        id="Store-icon-svg"
        className={className}
        component="div"
        onKeyPress={onStorePinClicked}
        onClick={onStorePinClicked}
      >
        {!showStoreDetails ? (
          renderIcon(brandId, isNewMiddleNavSection)
        ) : (
          <CloseIcon brand={brandId} />
        )}
      </BodyCopy>
      {showStoreDetails &&
        renderStoreDetailDropDown({
          basicInfo,
          storeTime,
          onLinkClick,
          onStorePinClicked,
          showStoreDetails,
          handleChangeStoreClick,
          handleShopThisStoreClick,
          headerMiddleNavHeight,
          fromCondensedHeader,
          isShopThisStoreEnabled,
          storeData,
          resetCurrentStoreInfo,
        })}
    </React.Fragment>
  );
};

StoreLocatorLink.propTypes = {
  className: PropTypes.string.isRequired,
  store: PropTypes.shape({
    basicInfo: PropTypes.shape({}),
    hours: PropTypes.shape({
      regularHours: PropTypes.shape([]),
      regularAndHolidayHours: PropTypes.shape([]),
      holidayHours: PropTypes.shape([]),
    }),
    features: PropTypes.shape({}),
  }),
  brandId: PropTypes.string.isRequired,
  onStorePinClicked: PropTypes.func,
  onLinkClick: PropTypes.func,
  showStoreDetails: PropTypes.bool,
  handleChangeStoreClick: PropTypes.func,
  handleShopThisStoreClick: PropTypes.func,
  isShopThisStoreEnabled: PropTypes.bool,
  isNewMiddleNavSection: PropTypes.bool,
};

StoreLocatorLink.defaultProps = {
  store: {
    basicInfo: {
      id: '',
      storeName: '',
      phone: '',
      coordinates: {},
      address: {},
    },
    hours: {
      regularHours: [],
      regularAndHolidayHours: [],
      holidayHours: [],
    },
  },
  onLinkClick: () => {},
  onStorePinClicked: () => {},
  showStoreDetails: false,
  handleChangeStoreClick: () => {},
  handleShopThisStoreClick: () => {},
  isShopThisStoreEnabled: false,
  isNewMiddleNavSection: false,
};

export default withStyles(StoreLocatorLink, style);

export { StoreLocatorLink as StoreLocatorLinkVanilla };
